import { IMaximizable, WidgetBase } from '../../widgets/models';
import { Helper } from '../../common';
import { TextConfiguration } from './text.configuration';
import { textWidgetDefinition as definition } from '../../widgets/widgets.definition.index';
import { WidgetTextData } from '../../widgets/models';

export class TextWidget extends WidgetBase implements IMaximizable {
    baseType = definition.baseType;
    col = 0;
    configuration: TextConfiguration = {
        dateFormat: '',
        text: '',
        theme: 0,
        hasSanitization: true
    };
    data?: WidgetTextData;
    guid: string;
    hasExtendedProperties = true;
    highlights = definition.highlights;
    icon = definition.icon;
    isDisabledMaximized: boolean = false;
    isMaximizable: boolean = true;
    isMaximized: boolean = false;
    name = definition.title;
    row = 0;
    sizeX = 6;
    sizeY = 4;
    type = definition.type;

    constructor() {
        super();
        this.guid = Helper.getGuid();
    }

    sanitize(): void {
        super.sanitize();
        if (this.configuration && this.configuration.theme !== undefined) {
            this.configuration.theme = 1;
        }
    }
}